import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import SpotlightSlider from "./SpotlightSlider";
import PrescriptionOptions from "./Priscription/PrescriptionOptions";
import PopularTest from "./PopularTest";
import SpecializedBanner from "./SpecializedBanner";
import ShopByCategory from "./ShopByCategory";
import AfterCategoryBanner from "./AfterCategoryBanner";
import FeaturedBrands from "./FeaturedBrands";
import OfferForYou from "./OfferForYou";
import Package from "../LabTest/Packages";
import TrendingToday from "./TrendingToday";
import NewBanner from "./NewBanner";
import CategorySection from "./CategoreySection.js";
import WhyChooseUs from "./WhyChooseUs.js";
import GetPartner from "./Partner/GetPartner";
import LoginPopup from "../common/LoginPopup"; // 👈 add

export default function AllFillter() {
  const [showLogin, setShowLogin] = useState(false); // 👈 add

  return (
    <div
      className="container-fluid my-4 mt-5 px-3"
      style={{ overflowX: "hidden" }}
    >
      <SpotlightSlider />
      <CategorySection />
   

      {/* 👇 yaha fix */}
      <PrescriptionOptions setShowLogin={setShowLogin} />
      <GetPartner/>
      <PopularTest />
      <SpecializedBanner />
      <Package /> 
      <ShopByCategory />
      <AfterCategoryBanner />
      <FeaturedBrands />
      <TrendingToday />
      
      <NewBanner />
      
      <OfferForYou />
       <WhyChooseUs/>
      {/* 👇 Login Popup */}
      <LoginPopup
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
      />
    </div>
  );
}